export class SetFocus{
    public to(fieldName: string, isFocusSet:boolean): boolean {
       try{
            if (!isFocusSet)
                document.getElementById(fieldName).focus();
            return true;
        } catch (e) {
            return false;
        }
    }
}


// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/shared/setFocus.ts